import { isWheelLootbox } from '../../../helpers/realTimeService';
import { isScratchLootbox } from './scratchGame';
import { Lootbox } from '@/api/common';

enum LootboxTag {
  WHEEL = 'wheel',
  SCRATCH_GAME = 'scratch_game',
}

const isWithoutTagLootbox = (lootbox: Lootbox) =>
  !isWheelLootbox(lootbox) && !isScratchLootbox(lootbox);

const tagLootboxMap = {
  [LootboxTag.WHEEL]: isWheelLootbox,
  [LootboxTag.SCRATCH_GAME]: isScratchLootbox,
};

const filterLootboxesByTag =
  (tag: LootboxTag | null) => (lootboxes?: Lootbox[]) => {
    if (!lootboxes) return [];

    return lootboxes.filter((lootbox) => {
      return tag ? tagLootboxMap[tag](lootbox) : isWithoutTagLootbox(lootbox);
    });
  };
export const findWheelLootboxes = filterLootboxesByTag(LootboxTag.WHEEL);
export const findScratchLootboxes = filterLootboxesByTag(
  LootboxTag.SCRATCH_GAME
);
export const findLootboxesWithoutTags = filterLootboxesByTag(null);
